import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconNavigation = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#818181",
		d: "M3.333 6.667h3.333V3.333H3.333v3.334zm5 10h3.333v-3.334H8.333v3.334zm-5 0h3.333v-3.334H3.333v3.334zm0-5h3.333V8.333H3.333v3.334zm5 0h3.333V8.333H8.333v3.334zm5-8.334v3.334h3.333V3.333h-3.333zm-5 3.334h3.333V3.333H8.333v3.334zm5 5h3.333V8.333h-3.333v3.334zm0 5h3.333v-3.334h-3.333v3.334z"
	})
});
export default SvgIconNavigation;
